import React from 'react';

import Button from '../../../components/ui/Button';
import { addAllFacebookParamsToUrl } from '../../../utils/trackingParams';
import { useAssessment } from '../../../components/navigation/AssessmentStateManager';

const CTASection = ({ dominant, secondary }) => {
  const { state } = useAssessment();
  const archetypeTitles = {
    performer: 'Performer',
    ghost: 'Ghost',
    controller: 'Controller',
    pleaser: 'Pleaser',
    destroyer: 'Destroyer'
  };

  const dominantTitle = archetypeTitles?.[dominant] || 'Performer';
  const secondaryTitle = archetypeTitles?.[secondary] || 'Ghost';

  const handleChallengeClick = () => {
    const baseUrl = 'https://limitlessmen.com/masterclass-room?utm_source=assessment';
    const emailParam = state?.email ? `&email=${encodeURIComponent(state?.email)}` : '';
    const challengeUrl = `${baseUrl}${emailParam}`;
    const urlWithTracking = addAllFacebookParamsToUrl(challengeUrl);
    window.location.href = urlWithTracking;
  };

  return (
    <div className="bg-brand-charcoal rounded-lg p-8 md:p-10 border border-brand-slate">
      <h2 className="text-2xl md:text-3xl font-bold text-brand-white mb-6 uppercase tracking-tight">
        What To Do Next
      </h2>
      
      <p className="text-base md:text-lg text-brand-steel leading-relaxed mb-6">
        Escaping your False Self isn't about trying harder. It's about understanding the operating system that's been running you—and installing something new.
      </p>

      <p className="text-base md:text-lg text-brand-steel leading-relaxed mb-8">
        In this free masterclass, I break down exactly why you keep starting strong and fading—and the 4-step process to finally break the cycle.
      </p>
      
      <p className="text-base md:text-lg text-brand-steel leading-relaxed mb-10">
        50 minutes. No fluff. Built for men running the patterns you just identified.
      </p>
      
      <Button
        variant="default"
        size="lg"
        iconName="ArrowRight"
        iconPosition="right"
        onClick={handleChallengeClick}
        fullWidth
        className="mb-10"
      >
        WATCH THE MASTERCLASS NOW
      </Button>
    </div>
  );
};

export default CTASection;